<script lang="ts">
  export let name;
</script>

<div>
  <h2>nested : { name }</h2>
</div>


<style lang="scss">
  div {
    h2 {
      color: green;
    }
  }
</style>
